export async function Base64ToFile(dataurl: any) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  let extension = ".png";

  if (mime === "image/jpeg") {
    extension = ".jpg";
  }
  if (mime === "image/webp") {
    extension = ".webp";
  }
  if (mime === "image/gif") {
    extension = ".gif";
  }

  return new File([u8arr], new Date().getTime() + extension, { type: mime });
}
